<div class="padding column background-grey-300 grey-color-700">
  <h3 class="text-md semi-bold">{{ 'ImpersonateModal.title' | translate }}</h3>
  <p [innerHTML]="'UserToImpersonateDataModal.text' | translate : { email: data.email }"></p>
</div>
<div class="button-container">
  <div class="vertical-center" *ngIf="canViewLogs">
    <mat-checkbox (change)="activateLogs = $event.checked"></mat-checkbox>
    {{ 'ImpersonateModal.checkbox' | translate }}
  </div>
  <button appLoadingButton mat-raised-button color="primary" (click)="getToken()">
    {{ 'UserToImpersonateDataModal.buttonText' | translate }}
  </button>
</div>
